<div class="capital-maintence-view">
  <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
    <div class="uitk-c-card uhc-font">
      <div class="uitk_new_header">
        <div class="uitk-l-grid__col--12 stk-container-tabl-header">
          <div class="col-8 mb-3">
            <mat-tab-group
              [hidden]="normalUser"
              [selectedIndex]="getSelectedTabIndex()"
              (selectedTabChange)="selectionTypeChange($event)"
              aria-label="ot labor proposal Tabs"
              role="tablist"
            >
              @for (tab of tabs; track tab) {
              <mat-tab [label]="tab.label" role="tab"></mat-tab>
              }
            </mat-tab-group>
            <div>
              @if (normalUser) {
              <label class="mdc-label myReqFontSize">My Requests</label>
              }
            </div>
          </div>
          @if (selectedOption === 'requests') {
          <app-my-prop-requests></app-my-prop-requests>
          } @if (selectedOption === 'approvals') {
          <app-my-prop-approvals [isUCMGOwner]="isUCMGOwner"></app-my-prop-approvals>
          }
        </div>
      </div>
    </div>
  </div>
</div>
